// Raw API calls for in-app purchasing — see docs/in_app_purchasing_api_guide.md.
// `get`/`post` come from `utils/api`, the shared axios instance whose baseURL is
// `${origin}/api` — see src/account-dashboard/api.js for the same convention.
import { get, post, patch } from '../../utils/api';

const query = ({ group, includeIneligible } = {}) => {
  const params = new URLSearchParams();
  if (group) params.set('group', group);
  if (includeIneligible) params.set('include_ineligible', 'true');
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

// GET /v3/child_journals/:child_journal_id/purchase_options
export const getPurchaseOptions = (childJournalId, opts) =>
  get(`/v3/child_journals/${childJournalId}/purchase_options${query(opts)}`);

// POST /v3/child_journals/:child_journal_id/shopify_draft_orders
// A plain JSON body — `{ items: [...] }` — not the JSON:API envelope used
// elsewhere, per the API guide §5: there is no JSON:API shape for a basket.
export const postShopifyDraftOrder = (childJournalId, items) =>
  post(`/v3/child_journals/${childJournalId}/shopify_draft_orders`, { items });

// GET /v3/shopify_draft_orders/:id — polled after checkout.
export const getShopifyDraftOrder = id => get(`/v3/shopify_draft_orders/${id}`);

// DELETE /v3/shopify_draft_orders/:id — cancels an unpaid ("open") draft order
// from the "Continue with your order?" screen. Not in the current API guide
// (which states there is no PATCH or DELETE on this resource, only abandon-
// and-replace) — this is a new endpoint the backend needs to add; confirm the
// route and method with backend before relying on it against a real store.
export const cancelShopifyDraftOrder = id => patch(`/v3/shopify_draft_orders/${id}/cancel`);
